import { CatIconPhone } from '@blocks-react/components/Icons/Phone';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { Conditional } from '../../../common';
 
interface DealerLocatorSearchResultMobileContactProps {
  children?: string;
  showPhoneIcon?: boolean;
}

export const DealerLocatorSearchResultMobileContact = ({
  children,
  showPhoneIcon = false
}: DealerLocatorSearchResultMobileContactProps) => (
  <CatTextLink>
    <Conditional test={showPhoneIcon}>
      <CatIconPhone className="mt-1 me-2" />
    </Conditional>
    {children}</CatTextLink>
);
